/**
 * `kind: TEXT` — free text.
 *
 * The canvas edits no extra fields for this kind, so there is nothing to configure. One live
 * question uses it (the "other purposes, please specify" tail of the fifth tree).
 */
import { Input } from '@amzn/awsui-components-react';

import type { AnswerControlProps } from '../answerTypes';

export default function TextAnswer({ value, onChange, readOnly }: AnswerControlProps) {
  return (
    <Input
      readOnly={readOnly}
      value={typeof value === 'string' ? value : ''}
      onChange={({ detail }) => onChange(detail.value || undefined)}
    />
  );
}
